import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaBook,
  FaChartBar,
  FaCog,
  FaFolderOpen,
  FaCheckCircle,
  FaCalendarAlt,
  FaChartLine,
  FaGraduationCap,
  FaTasks,
  FaPenNib,
  FaEnvelopeOpenText,
  FaPaperPlane,
  FaReceipt,
  FaStar,
  FaQuestionCircle,
  FaConciergeBell,
} from "react-icons/fa";

const navItems = [
  {
    label: "Dashboard",
    to: "/admin-dashboard",
    icon: FaTachometerAlt,
  },
  {
    label: "Users",
    to: "/admin/users",
    icon: FaUsers,
  },
  {
    label: "Courses",
    to: "/admin/courses",
    icon: FaBook,
  },
  {
    label: "Blog",
    to: "/admin/blog",
    icon: FaPenNib,
  },
  {
    label: "Messages",
    to: "/admin/contact",
    icon: FaEnvelopeOpenText,
  },
  {
    label: "Newsletter",
    to: "/admin/newsletter",
    icon: FaPaperPlane,
  },
  {
    label: "Orders",
    to: "/admin/orders",
    icon: FaReceipt,
  },
  {
    label: "Reviews",
    to: "/admin/reviews",
    icon: FaStar,
  },
  {
    label: "FAQs",
    to: "/admin/faqs",
    icon: FaQuestionCircle,
  },
  {
    label: "Services",
    to: "/admin/services",
    icon: FaConciergeBell,
  },
  {
    label: "Reports",
    to: "/admin/reports",
    icon: FaChartBar,
  },
  {
    label: "Settings",
    to: "/admin/settings",
    icon: FaCog,
  },
  {
    label: "Projects",
    to: "/admin/projects",
    icon: FaFolderOpen,
  },
  {
    label: "Approvals",
    to: "/admin/approvals",
    icon: FaCheckCircle,
  },
  {
    label: "Interviews",
    to: "/admin/interviews",
    icon: FaCalendarAlt,
  },
  {
    label: "Task & Review",
    to: "/admin/task-reviews",
    icon: FaTasks,
  },
  {
    label: "Analytics",
    to: "/admin/analytics",
    icon: FaChartLine,
  },
  {
    label: "Internship",
    to: "/admin/internship",
    icon: FaGraduationCap,
  },
  {
    label: "Internship Openings",
    to: "/admin/internship-openings",
    icon: FaGraduationCap,
  },
];

function AdminSidebar({ isOpen }) {
  return (
    <aside className={`admin-sidebar ${isOpen ? "open" : "collapsed"}`}>
      <div className="admin-sidebar__brand">
        <span className="admin-sidebar__brand-mark" aria-hidden="true"><FaGraduationCap /></span>
        <span className="admin-sidebar__brand-text">
          <span className="admin-sidebar__brand-main">ByteGurukul</span>
          <span className="admin-sidebar__brand-sub">Admin panel</span>
        </span>
      </div>

      <nav className="admin-sidebar__nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `admin-sidebar__link${isActive ? " admin-sidebar__link--active" : ""}`
              }
              end
            >
              <Icon className="admin-sidebar__icon" />
              <span className="admin-sidebar__label">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}

export default AdminSidebar;
